var obj = [
"aardvark",
"abacus",
"accordion",
"acetate",
"acid",
"acorn",
"acrylic",
"ad",
"adapter",
"advertisement",
"affidavit",
"aftershave",
"agenda",
"air",
"airbag",
"airbus",
"aircraft",
"airfare",
"airfield",
"alarm",
"albatross",
"album",
"alcohol",
"ale",
"alfalfa",
"alligator",
"alloy",
"ambulance",
"ammunition",
"anchovy",
"android",
"animal",
"anime",
"anise",
"ankle",
"anklet",
"ant",
"anteater",
"antelope",
"antennae",
"antibody",
"antique",
"antler",
"anything",
"ape",
"apparatus",
"apparel",
"appetizer",
"apple",
"applewood",
"appliance",
"application",
"apricot",
"apron",
"archives",
"ark",
"arm-rest",
"arm",
"armadillo",
"armchair",
"armoire",
"armor",
"armpit",
"armrest",
"arrow",
"artichoke",
"artifact",
"ash",
"ashtray",
"asparagus",
"asphalt",
"ass",
"ATM",
"atom",
"auto",
"automaton",
"avalanche",
"avocado",
"award",
"baboon",
"back",
"backbone",
"backpack",
"backyard",
"bacon",
"badge",
"badger",
"bag",
"bagel",
"baggage",
"bagpipe",
"bail",
"bait",
"bakeware",
"balaclava",
"ball",
"balloon",
"ballot",
"bamboo",
"banana",
"bandana",
"banjo",
"bankbook",
"banner",
"barbeque",
"barbiturate",
"barge",
"bark",
"barley",
"barometer",
"barrel",
"barstool",
"base",
"basil",
"basket",
"bass",
"bassinet",
"bassoon",
"bat",
"bathrobe",
"battery",
"bead",
"beak",
"beam",
"bean",
"beanie",
"beanstalk",
"bear",
"beard",
"beast",
"beaver",
"bed",
"bee",
"beef",
"beer",
"beet",
"beetle",
"bell",
"bellows",
"bells",
"belly",
"belt",
"bench",
"beret",
"berry",
"beverage",
"bicycle",
"bidet",
"bifocals",
"bike",
"bikini",
"bill",
"billboard",
"binoculars",
"birch",
"bird",
"birdcage",
"birdhouse",
"biscuit",
"blackberry",
"blackbird",
"blackboard",
"bladder",
"blade",
"blanket",
"blazer",
"blinker",
"blister",
"blizzard",
"blood",
"blossom",
"blouse",
"blowgun",
"blowhole",
"blueberry",
"boardwalk",
"boat",
"body",
"bomb",
"bone",
"bonfire",
"bongo",
"book",
"bookcase",
"bookend",
"booklet",
"bookmark",
"books",
"boot",
"bootie",
"boulder",
"bow",
"bowl",
"bowtie",
"box",
"boxspring",
"boysenberry",
"bra",
"brace",
"bracelet",
"brain",
"brake",
"branch",
"brandy",
"bratwurst",
"bread",
"breadcrumb",
"breadfruit",
"breakfast",
"breast",
"breeze",
"brick",
"bridge",
"broccoli",
"broom",
"brow",
"brownie",
"brush",
"bubble",
"bucket",
"buckle",
"buckwheat",
"bud",
"buffalo",
"bug",
"building",
"bulb",
"bull",
"bulldozer",
"bullet",
"bumper",
"burrito",
"bus",
"bush",
"butane",
"butter",
"butterfly",
"button",
"buzz",
"buzzard",
"c-clamp",
"cabbage",
"cabin",
"cabinet",
"cable",
"cacao",
"cactus",
"caffeine",
"cage",
"cake",
"calculator",
"calendar",
"calf",
"call",
"camel",
"camera",
"camp",
"can",
"cancer",
"candle",
"candy",
"cane",
"cannon",
"canoe",
"canon",
"cantaloupe",
"canteen",
"canvas",
"cap",
"cape",
"cappuccino",
"caption",
"car",
"caramel",
"carbohydrate",
"carbon",
"card",
"cardboard",
"cardigan",
"cargo",
"caribou",
"carol",
"carp",
"carpet",
"carpeting",
"carriage",
"carrier",
"carrot",
"cars",
"cart",
"cartilage",
"cartoon",
"cartridge",
"carving",
"cascade",
"case",
"cash",
"cashew",
"casket",
"casserole",
"cast",
"cat",
"catalogue",
"caterpillar",
"cats",
"cattle",
"cauliflower",
"caviar",
"CD",
"ceiling",
"celery",
"cell",
"cello",
"cement",
"centre",
"ceramic",
"cereal",
"certificate",
"chain",
"chair",
"chairlift",
"chaise",
"chalk",
"champagne",
"chandelier",
"change",
"chard",
"charger",
"chart",
"chassis",
"chatter",
"check",
"checkbook",
"cheddar",
"cheek",
"cheese",
"cheesecake",
"cheetah",
"cherry",
"chess",
"chest",
"chestnut",
"chicken",
"chili",
"chime",
"chimpanzee",
"chin",
"chinchilla",
"chip",
"chipmunk",
"chit-chat",
"chive",
"chives",
"chocolate",
"choir",
"choker",
"chops",
"chopstick",
"chord",
"chorus",
"chow",
"chowder",
"chrysalis",
"cigarette",
"cilantro",
"cinder",
"cinnamon",
"circle",
"circuit",
"citron",
"citrus",
"clam",
"clamp",
"clank",
"clarinet",
"clasp",
"class",
"clave",
"clavicle",
"clavier",
"claw",
"clay",
"cleaner",
"cleat",
"cleavage",
"click",
"cliff",
"clip",
"clipboard",
"clipper",
"cloak",
"clock",
"clogs",
"cloister",
"clone",
"cloth",
"clothes",
"clothing",
"cloud",
"cloudburst",
"clove",
"clover",
"club",
"clue",
"coal",
"coaster",
"coat",
"cob",
"cobbler",
"cobweb",
"cockroach",
"cocktail",
"cocoa",
"coconut",
"cod",
"code",
"coffee",
"coffin",
"coil",
"coin",
"coke",
"collagen",
"collar",
"collection",
"colon",
"column",
"comb",
"comic",
"comma",
"comment",
"commercial",
"committee",
"compass",
"component",
"compost",
"compress",
"computer",
"concert",
"concrete",
"conditioner",
"condor",
"cone",
"conga",
"console",
"constitution",
"contact lens",
"container",
"contract",
"controller",
"conversation",
"convertible",
"cookbook",
"cookie",
"copy",
"coral",
"cord",
"corduroy",
"core",
"cork",
"corn",
"cornerstone",
"cornflakes",
"cornmeal",
"corral",
"corsage",
"costume",
"cot",
"cotton",
"couch",
"cougar",
"cough",
"coupon",
"course",
"cover",
"coverall",
"cow",
"cowbell",
"cows",
"coyote",
"crab",
"crack",
"cracker",
"cradle",
"cranberry",
"crane",
"crap",
"crate",
"crawdad",
"crayfish",
"crayon",
"cream",
"credenza",
"creme brulee",
"crepe",
"crib",
"cribbage",
"cricket",
"crocodile",
"croissant",
"crop",
"cross-stitch",
"cross",
"crow",
"crumb",
"crystal",
"cub",
"cube",
"cucumber",
"cuff-link",
"cuisine",
"cup",
"cupboard",
"cupcake",
"curd",
"curry",
"curse",
"curtain",
"custard",
"cymbal",
"cyst",
"daffodil",
"dagger",
"daisy",
"dam",
"dandelion",
"dart",
"dashboard",
"database",
"daybed",
"debris",
"decimal",
"deer",
"demon",
"denim",
"deodorant",
"desk",
"desktop",
"device",
"dew",
"diagram",
"dial",
"diamond",
"diaper",
"diary",
"dick",
"dictionary",
"diesel",
"dime",
"dimple",
"dinosaur",
"dipstick",
"directory",
"dirt",
"dish",
"dishwasher",
"disk",
"display",
"document",
"documentary",
"dog",
"doll",
"dollar",
"dolphin",
"dome",
"donkey",
"donut",
"door",
"doorbell",
"doorknob",
"doorpost",
"doorway",
"dough",
"doughnut",
"download",
"dragon",
"dragonfly",
"dragonfruit",
"drain",
"drake",
"drapes",
"drawer",
"dress",
"drill",
"drink",
"drug",
"drum",
"duck",
"duffel",
"dulcimer",
"dumbwaiter",
"dump truck",
"dust",
"dynamite",
"e-mail",
"eagle",
"ear",
"eardrum",
"earmuffs",
"earplug",
"earrings",
"earthworm",
"easel",
"eel",
"egg",
"eggnog",
"eggplant",
"eggs",
"ego",
"elbow",
"electricity",
"electronics",
"elephant",
"elixir",
"elk",
"elm",
"email",
"embryo",
"encyclopedia",
"endorsement",
"energy",
"engine",
"entree",
"envelope",
"epee",
"episode",
"epoxy",
"equation",
"equipment",
"eraser",
"erection",
"escalator",
"essay",
"evening-wear",
"exam",
"examination",
"exhaust",
"exhibit",
"exit",
"explosion",
"eye",
"eyeball",
"eyebrow",
"eyeglasses",
"eyelashes",
"eyelids",
"eyeliner",
"eyes",
"fabric",
"face",
"facelift",
"facet",
"factory",
"fan",
"fang",
"fanlight",
"fanny-pack",
"fanny",
"fart",
"fascia",
"faucet",
"fawn",
"fax",
"feast",
"feather",
"fedora",
"fence",
"fender",
"ferryboat",
"fertilizer",
"fiberglass",
"fiddle",
"fig",
"figurine",
"file",
"film",
"finger",
"fingernail",
"fir",
"fire",
"firewall",
"fish",
"fishbone",
"fishnet",
"flag",
"flame",
"flavor",
"flax",
"flesh",
"flip-flops",
"flour",
"flower",
"flowers",
"flute",
"fly",
"flytrap",
"foam",
"fog",
"folder",
"folklore",
"fondue",
"font",
"food",
"foot",
"football",
"footnote",
"footprint",
"footrest",
"footstep",
"footstool",
"footwear",
"forearm",
"forehead",
"fork",
"foundation",
"fountain",
"fox",
"foxglove",
"fragrance",
"frame",
"framework",
"freckle",
"freezer",
"freon",
"frequency",
"fresco",
"fridge",
"fries",
"frog",
"frost",
"frosting",
"fruit",
"fuel",
"fur",
"furnace",
"furniture",
"gadget",
"gallbladder",
"gallon",
"galoshes",
"game",
"garbage",
"garlic",
"garment",
"gas",
"gasket",
"gasoline",
"gate",
"gator",
"gauge",
"gazelle",
"gear",
"geese",
"gel",
"gem",
"generator",
"geranium",
"gerbil",
"geyser",
"gherkin",
"gingerbread",
"ginseng",
"giraffe",
"girdle",
"glacier",
"gland",
"glass",
"glasses",
"glider",
"globe",
"glockenspiel",
"glove",
"glue",
"gnat",
"go-kart",
"goat",
"god",
"goggles",
"gold",
"goldfish",
"golf",
"gong",
"goose",
"gopher",
"gorilla",
"gossip",
"gown",
"grab-bag",
"graffiti",
"grain",
"granola",
"grape",
"grapefruit",
"graph",
"grass",
"grasshopper",
"gravel",
"gravy",
"gray",
"grease",
"greens",
"grenade",
"grill",
"grocery",
"guacamole",
"guestbook",
"guide",
"guitar",
"gum",
"gun",
"gunpowder",
"gutter",
"gyro",
"hacksaw",
"hair",
"halibut",
"ham",
"hamburger",
"hammer",
"hammock",
"hamster",
"hand",
"handgun",
"handle",
"handlebar",
"handrail",
"hands",
"handsaw",
"hard-hat",
"hardcover",
"hardhat",
"hardware",
"harmonica",
"harp",
"harpsichord",
"hashtag",
"hat",
"hatchet",
"hawk",
"hazel",
"hazelnut",
"head",
"headache",
"headlight",
"headline",
"headphones",
"headrest",
"heart",
"heartbeat",
"heater",
"hedgehog",
"heirloom",
"helicopter",
"helium",
"helmet",
"hemp",
"herb",
"herbs",
"heron",
"hiccups",
"hip",
"hoe",
"hog",
"homework",
"honey",
"honeybee",
"hood",
"hook",
"horn",
"hornet",
"horse",
"horseradish",
"horses",
"hose",
"hotdog",
"hourglass",
"hubcap",
"hummus",
"hurdle",
"hydrant",
"ice-cream",
"ice",
"icecream",
"icicle",
"icing",
"icon",
"id",
"igloo",
"illustration",
"image",
"impala",
"inbox",
"incense",
"index",
"indicator",
"ingredient",
"ink",
"insect",
"instrument",
"insulation",
"interface",
"internet",
"intestine",
"inventory",
"iris",
"iron",
"item",
"ivory",
"jackal",
"jacket",
"jackfruit",
"jade",
"jaguar",
"jalapeno ",
"jam",
"jar",
"jasmine",
"jaw",
"jeans",
"jeep",
"jelly",
"jellybeans",
"jellyfish",
"jet",
"jewel",
"joint",
"journal",
"jug",
"juice",
"jumper",
"jumpsuit",
"junk",
"kale",
"kangaroo",
"kayak",
"kazoo",
"kebab",
"kennel",
"ketchup",
"kettle",
"kettledrum",
"key",
"keyboard",
"keystone",
"kidney",
"kielbasa",
"kilt",
"kimono",
"kingfish",
"kiss",
"kite",
"kitten",
"kiwi",
"knee",
"knickers",
"knife",
"knock",
"knot",
"knuckle",
"koala",
"kohlrabi",
"kumquat",
"label",
"lace",
"ladder",
"ladle",
"ladybug",
"lamb",
"lamp",
"landing",
"landmine",
"landscape",
"lane",
"lantern",
"lap",
"laptop",
"larch",
"lard",
"lark",
"larva",
"laryngitis",
"lasagna",
"lashes",
"latex",
"lathe",
"latte",
"laugh",
"laundry",
"lava",
"lawn",
"lawsuit",
"leaf",
"leash",
"leather",
"leaver",
"lecture",
"leek",
"leg",
"legend",
"legging",
"legislation",
"legislature",
"legs",
"legume",
"lemon",
"lemonade",
"lemur",
"lens",
"lentil",
"leopard",
"leprosy",
"letter",
"letters",
"lettuce",
"level",
"lever",
"leveret",
"license",
"licorice",
"lid",
"lift",
"light",
"lighting",
"lightning",
"lightscreen",
"lilac",
"lily",
"limb",
"lime",
"limestone",
"limo",
"line",
"linen",
"liner",
"lining",
"linkage",
"linseed",
"lion",
"lip",
"lipid",
"lipstick",
"liquid",
"liquor",
"litter",
"littleneck",
"liver",
"livestock",
"lizard",
"llama",
"loaf",
"loafer",
"lobster",
"lock",
"locker",
"locket",
"locomotive",
"locust",
"lode",
"log",
"loggia",
"logo",
"loincloth",
"lollipop",
"longboat",
"loop",
"lord",
"lot",
"lotion",
"louse",
"lox",
"luggage",
"lumber",
"lunch",
"lunchmeat",
"lung",
"lute",
"lychee",
"lycra",
"lye",
"lynx",
"lyre",
"lyrics",
"macadamia",
"macaroni",
"macaroon",
"macaw",
"machine",
"maelstrom",
"magazine",
"maggot",
"magnet",
"mail",
"mailbox",
"mailer",
"maintainer",
"makeup",
"mallard",
"mallet",
"mambo",
"mammoth",
"manacle",
"manatee",
"mandarin",
"mandolin",
"mango",
"mantel",
"mantle",
"manufacturer",
"map",
"maple",
"maracas",
"marble",
"mare",
"margarine",
"margin",
"marimba",
"marionberry",
"mark",
"marker",
"market",
"marmalade",
"marshmallow",
"mascara",
"mask",
"masonry",
"massage",
"mast",
"mat",
"match",
"material",
"matrix",
"mattock",
"mattress",
"mayonnaise",
"meal",
"measles",
"measure",
"meat",
"meatball",
"meatloaf",
"medal",
"medication",
"medicine",
"melatonin",
"melon",
"membrane",
"meme",
"memo",
"menorah",
"menu",
"merchandise",
"mercury",
"meringue",
"message",
"metal",
"meteor",
"meter",
"methane",
"metro",
"metronome",
"mice",
"microphone",
"microwave",
"midden",
"milepost",
"milk",
"milkshake",
"mill",
"millet",
"millstone",
"mimosa",
"mincemeat",
"mineral",
"mini-skirt",
"minibus",
"mink",
"minnow",
"mint",
"mirror",
"missile",
"mist",
"mitten",
"mixer",
"moat",
"moccasins",
"mocha",
"mochi",
"model",
"modem",
"molar",
"molasses",
"molding",
"mole",
"molecule",
"money",
"monger",
"monitor",
"monkey",
"monocle",
"monopoly",
"monsoon",
"monster",
"monument",
"moon",
"moonlight",
"moonscape",
"moonshine",
"moose",
"mop",
"morsel",
"mortise",
"mosque",
"mosquito",
"moth",
"motor",
"motorboat",
"motorcar",
"motorcycle",
"mound",
"mouse",
"mousse",
"moustache",
"mouth",
"mouton",
"movie",
"mower",
"mozzarella",
"mud",
"muffin",
"mug",
"mule",
"muscat",
"muscatel",
"muscle",
"mushroom",
"music-box",
"music",
"muskrat",
"mussel",
"mustache",
"mustard",
"mutt",
"mutton",
"nail",
"nanoparticle",
"napkin",
"neck",
"necklace",
"necktie",
"nectar",
"nectarine",
"needle",
"negligee",
"neon",
"nerve",
"nest",
"nestling",
"net",
"netbook",
"netsuke",
"network",
"neuron",
"neuropathologist",
"newsletter",
"newspaper",
"newsprint",
"newsstand",
"nibble",
"nickel",
"nightgown",
"nightingale",
"nightlight",
"nightmare",
"nit",
"nitrogen",
"noise",
"noodle",
"nose",
"note",
"notebook",
"notepad",
"notice",
"notion",
"nougat",
"nourishment",
"novel",
"nudge",
"nuke",
"number",
"nut",
"nutmeg",
"nutrient",
"nylon",
"oak",
"oar",
"oat",
"oatmeal",
"obi",
"oboe",
"obsidian",
"ocelot",
"octagon",
"odometer",
"odyssey",
"oil",
"okra",
"olive",
"omelet",
"onion",
"opera",
"opium",
"opossum",
"orange",
"orangutan",
"orchestra",
"orchid",
"ore",
"oregano",
"organ",
"ornament",
"osprey",
"ostrich",
"otter",
"ottoman",
"ovary",
"oven",
"overcoat",
"owl",
"ox",
"oxford",
"oxygen",
"oyster",
"ozone",
"pacemaker",
"pack",
"package",
"packaging",
"packet",
"pad",
"paddle",
"paddock",
"page",
"pail",
"paint",
"painting",
"pajamas",
"palate",
"palm",
"pamphlet",
"pan",
"pancake",
"pancreas",
"panda",
"panel",
"pannier",
"panpipe",
"panther",
"panties",
"pants",
"pantsuit",
"panty",
"pantyhose",
"papaya",
"paper",
"paperback",
"parachute",
"parallelogram",
"parcel",
"parchment",
"pard",
"parka",
"parrot",
"parser",
"parsley",
"parsnip",
"particle",
"partridge",
"pass",
"passbook",
"passport",
"pasta",
"paste",
"pastry",
"pat",
"patch",
"pate",
"patty",
"pattypan",
"pavement",
"paw",
"pea",
"peach",
"peacoat",
"peacock",
"peanut",
"pear",
"pearl",
"pecan",
"pecker",
"pedal",
"peen",
"pegboard",
"pelican",
"pelt",
"pen",
"pence",
"pencil",
"pendant",
"pendulum",
"penguin",
"penicillin",
"penis",
"pennant",
"penny",
"peony",
"pepper",
"pepperoni",
"perfume",
"permafrost",
"permit",
"persimmon",
"pest",
"pet",
"petal",
"petition",
"petitioner",
"petticoat",
"pew",
"pheromone",
"phone",
"phosphate",
"photo",
"photodiode",
"photograph",
"photoreceptor",
"piano",
"piccolo",
"pick",
"pickaxe",
"picket",
"pickle",
"pickup",
"picture",
"pie",
"pig",
"pigeon",
"piglet",
"pigpen",
"pike",
"pilaf",
"pile",
"pill",
"pillar",
"pillbox",
"pillow",
"pimple",
"pin",
"pine",
"pineapple",
"pinecone",
"ping",
"pink",
"pinkie",
"pinot",
"pinstripe",
"pint",
"pinto",
"pinworm",
"pipe",
"pipeline",
"piracy",
"piss",
"pistol",
"pita",
"pitcher",
"pith",
"pizza",
"placebo",
"placode",
"plane",
"plant",
"planter",
"planula",
"plaster",
"plasterboard",
"plastic",
"plate",
"platelet",
"platform",
"platinum",
"platter",
"platypus",
"pleat",
"plier",
"plough",
"plover",
"plow",
"plug",
"plugin",
"plum",
"plume",
"plunger",
"plywood",
"pocket-watch",
"pocket",
"pocketbook",
"pod",
"podcast",
"poem",
"point",
"poison",
"poker",
"pole",
"polenta",
"poll",
"polliwog",
"pollutant",
"pollution",
"polo",
"polyester",
"polyp",
"pomegranate",
"pomelo",
"pompom",
"poncho",
"pony",
"pop",
"popcorn",
"poppy",
"popsicle",
"porcelain",
"porch",
"porcupine",
"pork",
"porpoise",
"port",
"porter",
"porthole",
"portrait",
"post",
"postage",
"postbox",
"poster",
"pot",
"potato",
"pottery",
"potty",
"pouch",
"poultry",
"powder",
"prayer",
"preserves",
"press",
"pretzel",
"prey",
"print",
"printer",
"prison",
"prize",
"probe",
"processor",
"produce",
"product",
"promenade",
"propane",
"property",
"proposal",
"proposition",
"prune",
"pub",
"publication",
"pudding",
"puddle",
"puffin",
"pug",
"puggle",
"pulley",
"pulse",
"puma",
"pump",
"pumpernickel",
"pumpkin",
"pumpkinseed",
"punch",
"pup",
"pupa",
"puppet",
"puppy",
"purchase",
"purple",
"purr",
"purse",
"puzzle",
"pyramid",
"quail",
"quart",
"quarter",
"quartet",
"quartz",
"questionnaire",
"quiche",
"quicksand",
"quill",
"quilt",
"quince",
"quinoa",
"quiver",
"rabbit",
"rabbits",
"raccoon",
"rack",
"radar",
"radiator",
"radio",
"radiosonde",
"radish",
"raft",
"rag",
"rail",
"raiment",
"rain",
"rainbow",
"raincoat",
"rainstorm",
"raisin",
"rake",
"ram",
"rambler",
"ramen",
"ramie",
"ranger",
"raspberry",
"rat",
"raven",
"ravioli",
"rawhide",
"ray",
"rayon",
"razor",
"reactant",
"reamer",
"rebellion",
"receipt",
"recipe",
"recliner",
"record",
"recorder",
"rectangle",
"reef",
"refectory",
"refreshments",
"refrigerator",
"refuse",
"register",
"regulator",
"reindeer",
"reject",
"relish",
"remnant",
"remote",
"replica",
"report",
"reserve",
"residue",
"resume",
"retina",
"revenant",
"revolver",
"reward",
"rhinoceros",
"rhubarb",
"rib",
"ribbon",
"rice",
"ridge",
"rifle",
"rim",
"ring",
"rings",
"ringworm",
"rip",
"riser",
"rivulet",
"roar",
"robe",
"robin",
"robot",
"rock",
"rocket-ship",
"rocket",
"rod",
"roller",
"romaine",
"roof",
"rooster",
"root",
"rope",
"rose",
"rosemary",
"rostrum",
"router",
"row",
"rowboat",
"rub",
"rubber",
"rubbish",
"ruby",
"ruffle",
"rug",
"rugby",
"ruin",
"ruler",
"rum",
"runway",
"rust",
"rutabaga",
"rye",
"sabre",
"sac",
"sack",
"saddle",
"safe",
"safeguard",
"saffron",
"sage",
"sail",
"sailboat",
"sake",
"salad",
"salami",
"salmon",
"salsa",
"salt",
"sample",
"sand",
"sandal",
"sandpaper",
"sandwich",
"sardine",
"sari",
"sarong",
"sash",
"satellite",
"satin",
"sauce",
"saucer",
"sauerkraut",
"sausage",
"saw",
"saxophone",
"scaffold",
"scale",
"scallion",
"scallops",
"scalp",
"scanner",
"scarecrow",
"scarf",
"scent",
"schnitzel",
"schoolhouse",
"schooner",
"scimitar",
"scissors",
"scooter",
"scorpion",
"scotch",
"scow",
"scrap",
"screen",
"screw",
"screwdriver",
"scrim",
"script",
"scripture",
"seabass",
"seafood",
"seagull",
"seal",
"seaplane",
"seat",
"seaweed",
"secretion",
"sectional",
"sediment",
"seed",
"seeder",
"seizure",
"semicircle",
"semiconductor",
"senate",
"sepal",
"serum",
"serval",
"sesame",
"set",
"sewer",
"sex",
"shackle",
"shade",
"shadow",
"shadowbox",
"shake",
"shaker",
"shallot",
"shallows",
"shampoo",
"shark",
"shaw",
"shawl",
"shear",
"sheath",
"shed",
"sheep",
"sheet",
"shelf",
"shell",
"shelter",
"sherbet",
"sherry",
"shield",
"shin",
"shingle",
"ship",
"shirt",
"shirtdress",
"shit",
"shoat",
"shock",
"shoe",
"shoehorn",
"shoelace",
"shoes",
"shoestring",
"shofar",
"shoot",
"short",
"shorts",
"shortwave",
"shot",
"shoulder",
"shout",
"shovel",
"show",
"shower",
"shrimp",
"sideboard",
"sideburns",
"sidecar",
"sidestream",
"sidewalk",
"siding",
"sigh",
"sight",
"sign",
"signal",
"signet",
"silence",
"silica",
"silicon",
"silk",
"silkworm",
"sill",
"silo",
"silver",
"sink",
"sitar",
"skate",
"skean",
"skeleton",
"ski",
"skin",
"skirt",
"skull",
"skullcap",
"skunk",
"skylight",
"slate",
"slaw",
"sled",
"sledge",
"slice",
"slide",
"slime",
"slip",
"slipper",
"slippers",
"slope",
"slot",
"sloth",
"smell",
"smith",
"smock",
"smog",
"smoke",
"smolt",
"snack",
"snail",
"snake",
"snakebite",
"snap",
"sneaker",
"sneeze",
"sniffle",
"snow",
"snowflake",
"snowman",
"snowplow",
"snowstorm",
"snowsuit",
"soap",
"sock",
"socks",
"soda",
"sofa",
"softball",
"softdrink",
"software",
"soil",
"sole",
"sombrero",
"sonar",
"sonata",
"song",
"songbird",
"songs",
"sonnet",
"soot",
"sorbet",
"sorrel",
"sound",
"soup",
"sourwood",
"sousaphone",
"sow",
"soy",
"soybean",
"spade",
"spaghetti",
"spandex",
"sparerib",
"spark",
"sparrow",
"spasm",
"spatula",
"speakerphone",
"spear",
"spectacles",
"spectrograph",
"spectrum",
"speech",
"speedboat",
"sphere",
"sphynx",
"spice",
"spider",
"spiderling",
"spiders",
"spike",
"spill",
"spinach",
"spine",
"spiral",
"spleen",
"sponge",
"spool",
"spoon",
"spork",
"sport",
"spotlight",
"sprag",
"sprat",
"spreadsheet",
"sprinkles",
"sprout",
"spruce",
"spud",
"spume",
"spur",
"spyglass",
"square",
"squash",
"squeegee",
"squid",
"squirrel",
"stab",
"stable",
"stack",
"stadium",
"stag",
"stain",
"stair",
"staircase",
"stake",
"stalk",
"stall",
"stallion",
"stamen",
"stamp",
"star",
"start",
"state",
"station-wagon",
"station",
"statue",
"steak",
"steam",
"steamroller",
"steel",
"steeple",
"stem",
"stench",
"stencil",
"step",
"stepping-stone",
"stereo",
"stew",
"steward",
"stick",
"sticker",
"sticks",
"stiletto",
"sting",
"stinger",
"stir-fry",
"stitch",
"stitcher",
"stocking",
"stockings",
"stole",
"stomach",
"stone",
"stonework",
"stool",
"stopsign",
"stopwatch",
"storage",
"store",
"storey",
"storm",
"story",
"storyboard",
"stove",
"strait",
"strap",
"straw",
"strawberry",
"strawman",
"stream",
"street",
"streetcar",
"string",
"strip",
"stripe",
"strobe",
"structure",
"strudel",
"stucco",
"stud",
"studio",
"study",
"stump",
"sturgeon",
"sty",
"stylus",
"sub",
"submarine",
"substance",
"succotash",
"sucker",
"suede",
"suet",
"sugar",
"suit",
"suitcase",
"suite",
"sulfur",
"sultan",
"summit",
"sun",
"sunbeam",
"sunbonnet",
"sundae",
"sundial",
"sunflower",
"sunglasses",
"sunlamp",
"sunlight",
"sunrise",
"sunroom",
"sunshine",
"supper",
"supplement",
"supplier",
"surface",
"surfboard",
"sushi",
"suspenders",
"SUV",
"swamp",
"swan",
"swanling",
"sweat",
"sweater",
"sweatshirt",
"sweatsuit",
"sweets",
"swimsuit",
"swine",
"swing",
"switch",
"switchboard",
"sword",
"swordfish",
"sycamore",
"symbol",
"syrup",
"t-shirt",
"tab",
"tabby",
"tabernacle",
"table",
"tablecloth",
"tablet",
"tabletop",
"tachometer",
"tackle",
"taco",
"tadpole",
"tail",
"tailbud",
"take-out",
"talk",
"tamale",
"tambourine",
"tan",
"tangerine",
"tank-top",
"tank",
"tanker",
"tap",
"tape",
"tapioca",
"target",
"taro",
"tarragon",
"tart",
"tassel",
"tattoo",
"taxi",
"tea",
"teapot",
"tear",
"tech",
"teepee",
"teeth",
"telephone",
"telescreen",
"teletype",
"temple",
"tennis",
"tentacle",
"teriyaki",
"termite",
"terracotta",
"terrapin",
"text",
"textbook",
"thermometer",
"thermostat",
"thigh",
"thing",
"things",
"thistle",
"thong",
"thongs",
"thorn",
"thread",
"threshold",
"throat",
"throne",
"thrush",
"thumb",
"thunder",
"thunderbolt",
"thunderhead",
"thunderstorm",
"thyme",
"tiara",
"tic",
"tick",
"ticket",
"tide",
"tie",
"tiger",
"tights",
"tile",
"till",
"timbale",
"timber",
"timer",
"timetable",
"timpani",
"tin",
"tinderbox",
"tinkle",
"tintype",
"tire",
"tissue",
"titanium",
"toad",
"toast",
"toaster",
"tobacco",
"toe",
"toenail",
"toes",
"toffee",
"tofu",
"tog",
"toga",
"toilet",
"toll",
"tom-tom",
"tomatillo",
"tomato",
"tomatoes",
"tongue",
"tonic",
"tool",
"toot",
"tooth",
"toothbrush",
"toothpaste",
"toothpick",
"top-hat",
"topsail",
"toque",
"toreador",
"tornado",
"torso",
"torte",
"tortellini",
"tortilla",
"tortoise",
"tote",
"tow-truck",
"towel",
"tower",
"townhouse",
"toy",
"toys",
"track",
"tracksuit",
"tract",
"tractor",
"traffic",
"trail",
"trailer",
"train",
"trainer",
"trains",
"tram",
"tramp",
"transcript",
"transom",
"trap",
"trapdoor",
"trapezium",
"trapezoid",
"trash",
"tray",
"treasure",
"treat",
"tree",
"trees",
"trek",
"trellis",
"tremor",
"trench",
"triangle",
"tribe",
"tributary",
"trigger",
"trinket",
"tripod",
"trolley",
"trombone",
"troop",
"trooper",
"trophy",
"trousers",
"trout",
"trove",
"trowel",
"truck",
"trucks",
"trumpet",
"trunk",
"tsunami",
"tub",
"tuba",
"tube",
"tuber",
"tug",
"tugboat",
"tulip",
"tumbler",
"tummy",
"tuna",
"tune-up",
"tune",
"tunic",
"tunnel",
"turban",
"turf",
"turkey",
"turmeric",
"turnip",
"turnover",
"turnstile",
"turret",
"turtle",
"tusk",
"tutu",
"tuxedo",
"TV",
"tweet",
"tweezers",
"twig",
"twilight",
"twine",
"twist",
"twister",
"twitter",
"typewriter",
"typhoon",
"ukulele",
"umbrella",
"underclothes",
"underground",
"underpants",
"underpass",
"undershirt",
"underwear",
"underwire",
"uniform",
"urn",
"utensil",
"vaccine",
"vacuum",
"vagina",
"valance",
"valentine",
"valley",
"van",
"vane",
"vanilla",
"vase",
"vault",
"veal",
"vegetable",
"vegetation",
"vehicle",
"veil",
"vein",
"veldt",
"vellum",
"velodrome",
"velvet",
"vendor",
"veneer",
"venison",
"venom",
"venti",
"venue",
"veranda",
"vermicelli",
"vessel",
"vest",
"vibraphone",
"vibrissae",
"video",
"villa",
"vine",
"vinegar",
"vinyl",
"viola",
"violet",
"violin",
"virus",
"vise",
"visor",
"vista",
"vitamin",
"vixen",
"vodka",
"vogue",
"voice",
"volcano",
"volleyball",
"vomit",
"vulture",
"wad",
"waffle",
"wagon",
"waist",
"waistband",
"waiver",
"wake",
"walkway",
"wall",
"wallaby",
"wallet",
"walnut",
"walrus",
"wampum",
"wardrobe",
"wasabi",
"washbasin",
"washcloth",
"washer",
"washtub",
"wasp",
"waste",
"wastebasket",
"watch",
"water",
"waterbed",
"watercress",
"watermelon",
"waterspout",
"waterwheel",
"wave",
"waveform",
"waves",
"wax",
"way",
"weapon",
"weasel",
"web",
"webinar",
"webmail",
"wedge",
"weed",
"weeder",
"weedkiller",
"well",
"wet-bar",
"wetsuit",
"whale",
"wharf",
"wheat",
"wheel",
"whelp",
"whey",
"whip",
"whirlpool",
"whirlwind",
"whisker",
"whiskey",
"whisper",
"whistle",
"wick",
"widget",
"widow",
"wildebeest",
"wildlife",
"will",
"willow",
"wind-chime",
"wind",
"window",
"windscreen",
"windshield",
"wine",
"winery",
"wing",
"wingtip",
"winner",
"winter",
"wire",
"wiretap",
"wiring",
"wisteria",
"wok",
"wolf",
"wombat",
"wood",
"woodchuck",
"woodland",
"woodshed",
"woodwind",
"wool",
"woolens",
"workbench",
"workhorse",
"worm",
"wound",
"wrap",
"wrapper",
"wrapping",
"wrecker",
"wren",
"wrench",
"wriggler",
"wrinkle",
"wrist",
"xylophone",
"yacht",
"yahoo",
"yak",
"yam",
"yarmulke",
"yarn",
"yawl",
"yeast",
"yellow",
"yellowjacket",
"yogurt",
"yoke",
"yolk",
"yoyo",
"yurt",
"zebra",
"zebrafish",
"ziggurat",
"zinc",
"zipper",
"zither",
"zombie",
"zoot-suit",
"zucchini"
];

var place = [
"50s Suburbs",
"60s Drum Circle",
"70s Disco Club",
"80s Mall",
"90s Music Festival",
"A Blizzard",
"Abandoned Home",
"abbey",
"academy",
"acre",
"address",
"Airlock",
"Airplane Seats",
"Airport Gate",
"airport",
"airspace",
"Al fresco rooftop cinema",
"alcove",
"alley",
"Alligator World",
"Alpine chalet",
"Alpine meadow",
"altar",
"Amazon Jungle",
"Amish farm",
"Amphitheater",
"Amusement Park",
"antechamber",
"Antiques Store",
"anywhere",
"apartment",
"Apiary",
"Apollo Capsule",
"Apple Orchard",
"aquarium",
"Aquatic center",
"aquifer",
"Arboretum",
"Arcade hall",
"arcade",
"Architectural masterpiece guided tour",
"area",
"arena",
"Art Gallery",
"Art house cinema",
"Artisan chocolate shop",
"Artisanal craft beer brewery",
"Artist Studio",
"Asian fusion food truck",
"Asteroid Mine",
"atelier",
"atmosphere",
"atrium",
"attic",
"auditorium",
"Auto Repair Shop",
"avenue",
"Baby Shower",
"Back Alley",
"background",
"Backstage",
"bakery",
"balcony",
"Ball Pit",
"Ballet Studio",
"Ballet theater",
"ballpark",
"Bank Vault",
"bank",
"banquette",
"bar",
"barbeque",
"Barbershop",
"barge",
"barn",
"barracks",
"barrier",
"basement",
"basin",
"Basketball court",
"Basketball stadium",
"Batcave",
"bath",
"bathhouse",
"bathroom",
"bathtub",
"Battery Factory",
"battleship",
"bay",
"bayou",
"beach",
"Bed N Breakfast",
"bed",
"bedroom",
"Bee farm",
"bench",
"bend",
"Betting Parlour",
"Bike Shop",
"Bike trail",
"Billiard Room",
"Biodome",
"birdbath",
"birdcage",
"birdhouse",
"Birthday Party",
"Blood Stream",
"Blues bar",
"Board game café",
"Boardwalk amusement park",
"boardwalk",
"Boat Deck",
"boat",
"boatyard",
"Bonsai garden",
"Bookstore café",
"border",
"boss",
"Botanical conservatory",
"boudoir",
"boulevard",
"boundary",
"Boutique hotel",
"Bowling Alley",
"Bowling lounge",
"Boxing club",
"Boxing Ring",
"Brewery",
"Brewpub",
"bridge",
"brink",
"brook",
"Bubble tea shop",
"buffet",
"bungalow",
"Bunk Beds",
"bunkhouse",
"Burger Joint",
"Bus Stop",
"Butcher's",
"Butterfly garden",
"cafe",
"Café",
"Cajun restaurant",
"Call Center",
"Campsite",
"campus",
"canal",
"Candy Store",
"capital",
"Car Dealership",
"Carousel",
"Carpenter's Studio",
"carport",
"casino",
"castle",
"catacomb",
"cathedral",
"causeway",
"cave",
"ceiling",
"cellar",
"Cemetary",
"cemetery",
"cesspool",
"chalet",
"chamber",
"Change Room at a Store",
"channel",
"chapel",
"chasm",
"chateau",
"Chiropractors office",
"church",
"cinema",
"Circus Tent",
"city",
"classroom",
"cloakroom",
"closet",
"Co-working space",
"coast",
"cockpit",
"Cocktail lounge",
"Coffee plantation",
"College Campus",
"college",
"colony",
"Comic Con",
"Community center",
"Community garden",
"Community library",
"Community-driven urban garden",
"complex",
"Computer Lab",
"condominium",
"conference",
"congo",
"Construction site",
"continent",
"Corn Maze",
"corner",
"Coronation",
"corridor",
"cottage",
"couch",
"country",
"Countryside cabin retreat",
"countryside",
"county",
"Court Room",
"court",
"courthouse",
"courtroom",
"crack",
"cradle",
"Craft distillery",
"creek",
"crib",
"crotch",
"Cruise ship",
"Customer Service Desk",
"Dairy Farm",
"dairy",
"dam",
"Dance Hall",
"Dance studio",
"dance",
"daybed",
"Daycare",
"deck",
"den",
"Dentist's Chair",
"Dep/Bodega/Convenience Store",
"depot",
"derby",
"desert",
"dessert",
"destination",
"detention",
"diner",
"Dinner theater",
"dip",
"disco",
"district",
"Ditch",
"Dive bar",
"dock",
"Doctor's Office",
"Dog park",
"Dog-friendly café",
"Dolphin Research Lab",
"domain",
"dome",
"Donut Shop",
"Doomed Spaceship",
"Dorm Room",
"downstairs",
"downtown",
"Dr. Office",
"Dragon's Cave",
"drawbridge",
"dream",
"Drive-in theater",
"Drive-thru burger joint",
"Drive-thru coffee stand",
"driveway",
"Driving School",
"dugout",
"dump",
"dungeon",
"dwelling",
"earth",
"east",
"Eco-friendly floating village",
"Eco-friendly hotel",
"Eco-resort",
"Eco-village",
"ecosystem",
"edge",
"elevation",
"elevator",
"embassy",
"empire",
"English Pub",
"enterprise",
"entrance",
"Equestrian center",
"escalator",
"Escape game in an abandoned mine",
"Escape room",
"estate",
"Ethereal butterfly conservatory",
"Executive Office",
"exhibition",
"Exhilarating zipline adventure park",
"exit",
"facility",
"Fallout Shelter",
"Family-run bakery",
"Farm-to-cup coffee shop",
"Farm-to-table restaurant",
"farm",
"Farmers market",
"farmland",
"Fashion boutique",
"Fashion runway",
"Fast food restaurant",
"fence",
"festival",
"field",
"fireplace",
"firm",
"Fish market",
"fishery",
"Fishing Dock",
"Flash Mob",
"Flea Market",
"flight",
"Floating forest on a river barge",
"Floating lantern festival on a lake",
"Floating lantern festival",
"Floating market on traditional sampans",
"Floating market",
"Floating restaurant",
"Flooding Basement",
"floodplain",
"floor",
"Florist",
"Food cart pod",
"Food Cart/Truck",
"Food Court",
"Food fusion truck",
"Food pantry",
"Food truck",
"Forest glade",
"forest",
"Formula 1 Garage",
"fort",
"fortress",
"foundation",
"fountain",
"Fruit Market",
"Fruit orchard",
"Funeral Home",
"funeral",
"gallery",
"galley",
"game",
"Gaming arcade",
"Garage at Home",
"Garage Sale",
"garage",
"garden",
"Gas Station",
"gate",
"gateway",
"gauntlet",
"gazebo",
"Ghost ship",
"Ghost town",
"glacier",
"Gladiator Ring",
"Glamping site",
"globe",
"Goblin Hut",
"Golf Course",
"Golf Green",
"gondola",
"Gourmet floating restaurant on a boat",
"Gourmet food truck",
"Gourmet rooftop restaurant",
"Gourmet underground dining experience",
"Graffiti alley",
"grassland",
"Green house",
"Green rooftop",
"greenhouse",
"Grocery store",
"ground",
"Guided nature hike through a rainforest",
"gym",
"hacienda",
"Hair Salon",
"hall",
"hallway",
"Hammock garden",
"Hamster Cage",
"hanger",
"harbor",
"Hardware Store",
"Haunted House",
"Haunted mansion",
"Hayloft",
"headquarters",
"hearth",
"hedge",
"Heritage Theatre",
"Hidden gem antique shop",
"Hidden gem independent bookstore",
"Hidden speakeasy gin distillery",
"Hidden speakeasy",
"Hidden underground wine cellar",
"hide",
"High School Cafeteria",
"high-rise",
"highway",
"Hiking trail",
"hill",
"Historic bed and breakfast inn",
"Historic opera house",
"Historic windmill",
"Historical ghost walking tour",
"Historical mansion",
"Historical theater district",
"Historical walking tour",
"hive",
"Hoarder's Shed",
"hobbit",
"Hobo Rail Car",
"hole",
"home",
"homeland",
"hometown",
"horizon",
"hospice",
"hospital",
"hostel",
"Hot air balloon festival",
"Hot Dog Stand",
"Hot Tub",
"Hotel Lobby",
"hotel",
"house",
"houseboat",
"household",
"houses",
"hull",
"hut",
"Ice Cave",
"Ice cream parlour",
"Ice Cream Shop",
"Ice Fishing Shack",
"Ice rink",
"iceberg",
"igloo",
"Improv comedy club",
"inbox",
"Indoor rock climbing gym",
"Indoor trampoline park",
"Indoor water park",
"inn",
"Interactive children's museum",
"Interactive science museum",
"Interactive technology museum",
"island",
"Jail Cell",
"jail",
"jailhouse",
"Jazz club",
"Jazz festival",
"Jeweller's",
"Jewelry store",
"Juice bar",
"jungle",
"Junkyard",
"Kangaroo Pouch",
"Karaoke bar",
"kennel",
"Kindergarten Class",
"kiosk",
"kitchen",
"lab",
"laboratory",
"Labyrinth",
"Ladies Restroom",
"lake",
"land",
"landform",
"landing",
"landscape",
"lane",
"lap",
"larder",
"Laundromat",
"lawn",
"Lawyer Office",
"lecture",
"library",
"Life Raft",
"lift",
"lighthouse",
"Llama farm",
"lobby",
"Local food cooperative",
"locker",
"loft",
"loggia",
"Logging Camp",
"lookout",
"loop",
"lot",
"Lounge bar",
"lounge",
"lunchroom",
"maelstrom",
"mailbox",
"mainland",
"mall",
"Man Cave",
"mangrove",
"manor",
"mansion",
"mantel",
"mantle",
"Marina",
"market",
"marketplace",
"marsh",
"marshland",
"mat",
"matrix",
"meadow",
"Meat Freezer",
"mecca",
"Mechanic's Garage",
"Medieval Dungeon",
"Men's Restroom",
"meteor",
"metro",
"mezzanine",
"Microbrewery",
"midden",
"milepost",
"Military Tent",
"mill",
"mineshaft",
"moai",
"moat",
"monastery",
"monument",
"Moonbase Bravo",
"Morgue",
"motel",
"motorboat",
"motorcar",
"mound",
"Mountain cabin",
"mountain",
"Moving Van",
"Mt. Everest Base Camp",
"Mud Pit",
"Murder Scene",
"Museum Room",
"Museum Storage",
"museum",
"Neighborhood pub",
"neighborhood",
"nest",
"Newspaper Office",
"newsstand",
"Night market",
"nightclub",
"Nighttime wildlife safari",
"nursery",
"Nursing Home",
"oasis",
"Observation deck",
"observatory",
"ocean",
"Oceanfront boardwalk",
"off-ramp",
"Office Cubicle",
"office",
"Old West Town",
"Open-air botanical garden",
"opera",
"Operating Room",
"orchard",
"orchestra",
"Organic farm",
"Organic Grocery Store",
"outback",
"Outdoor concert venue",
"Outdoor yoga studio",
"Outdoors ATM",
"outhouse",
"Oval Office",
"oven",
"ozone",
"pagoda",
"palace",
"pantry",
"parade",
"park",
"party",
"pasture",
"patch",
"patio",
"pavilion",
"pawnshop",
"Peaceful lakeside picnic spot",
"peak",
"Pedestrian mall",
"peninsula",
"pentagon",
"Penthouse Apt",
"Pet store",
"pew",
"Photo Booth",
"Photobooth",
"picnic",
"pier",
"Piercing studio",
"pigsty",
"pillar",
"pit",
"plain",
"plane",
"Planet MB-204",
"planet",
"Planetarium",
"plantation",
"playground",
"playroom",
"Poker Room",
"Police Station",
"pond",
"pool",
"Pop-up art gallery",
"port",
"porthole",
"prairie",
"pressroom",
"Private Jet",
"prizefight",
"Public park",
"puddle",
"Pumpkin patch",
"pyramid",
"quicksand",
"Quilt shop",
"raft",
"rail",
"railroad",
"railway",
"rainbow",
"Rainforest canopy walkway",
"Rainforest canopy",
"ranch",
"Raspberry Field",
"Reception Desk",
"reception",
"Recording booth",
"Recording Studio",
"reef",
"refectory",
"refrigerator",
"remote",
"Renowned contemporary art gallery",
"reserve",
"reservoir",
"Rest stop",
"restaurant",
"restroom",
"ridge",
"rim",
"river",
"riverbed",
"Riverfront promenade",
"road",
"roadway",
"Rock climbing gym",
"rocket-ship",
"Rocky coastline",
"roof",
"Rooftop bar",
"Rooftop botanical garden",
"Rooftop cocktail lounge",
"Rooftop garden",
"Rooftop yoga and meditation studio",
"room",
"roundabout",
"rowboat",
"Rug store",
"rug",
"Rugby field",
"runway",
"Rustic winery",
"safari",
"Safe Room",
"sailboat",
"salon",
"saloon",
"Salsa club",
"Salt flats",
"Salt mine",
"sanctuary",
"sandbar",
"satellite",
"sauna",
"savannah",
"scaffold",
"Scenic horse-drawn carriage ride",
"Scenic mountain hiking trails",
"schoolhouse",
"schooner",
"Scuba diving spot",
"Sculpture garden",
"sea",
"seaplane",
"seashore",
"Seaside Cottage",
"seaside",
"Secluded beach cove",
"Secluded mountain cabin retreat",
"Secret rooftop jazz club",
"Secret underground cocktail bar",
"Secret underground distillery",
"Security Bunker",
"senate",
"Servant's Quarters",
"sewer",
"shack",
"shade",
"shallows",
"shanty",
"shed",
"shelter",
"ship",
"shipyard",
"Shoe Shop",
"Shoe store",
"shop",
"shore",
"shoreline",
"shower",
"shrine",
"sidecar",
"sidewalk",
"Silk farm",
"Singles Bar",
"Sinkhole",
"site",
"Skate Park",
"Skateboard park",
"Ski lodge",
"Ski resort",
"ski slope",
"sky",
"Skydiving center",
"skyline",
"skyscraper",
"skywalk",
"sled",
"Sleepover",
"slope",
"Slum Apt",
"Small Town Grocery Store",
"snowstorm",
"Soccer stadium",
"softball",
"Solar-powered eco-village",
"someplace",
"space",
"Speakeasy",
"speedboat",
"sport",
"stable",
"Stables",
"stadium",
"stage",
"stair",
"staircase",
"stall",
"Star's Dressing Room",
"star",
"starboard",
"Stasis Chamber",
"station-wagon",
"station",
"steeple",
"stepping-stone",
"Storage Locker",
"storage",
"store",
"Street art and graffiti tour",
"Street art district",
"Street corner",
"Street food market",
"street",
"streetcar",
"strip",
"structure",
"studio",
"submarine",
"suburb",
"Subway Car",
"subway",
"suite",
"Summer Camp",
"summer",
"summit",
"Sunflower field",
"Sunflower maze",
"sunroom",
"Sunset beach",
"Sunset kayaking excursion",
"Sunset vineyard",
"supermarket",
"Sushi bar",
"swamp",
"Sweat Shop",
"sweatshop",
"Swimming pool",
"swing",
"tavern",
"taxicab",
"Tea house",
"Teacher's Lounge",
"teepee",
"temple",
"tenement",
"Tennis Court",
"tent",
"tepee",
"terrace",
"terrarium",
"Terrasse",
"territory",
"The Afterlife",
"theater",
"Thrilling helicopter sightseeing tour",
"throne",
"Tiki bar",
"tomb",
"Top Secret Meeting Room",
"Torture Chamber",
"tower",
"town",
"townhouse",
"township",
"Trailer Home",
"Trampoline park",
"Tranquil waterfall",
"trapdoor",
"Tree house",
"trench",
"tributary",
"Tropical aquarium",
"Tropical rainforest",
"TV Studio",
"Underground jazz club",
"Underground live music venue",
"Underground nightclub",
"Underground speakeasy bar",
"underground",
"underpass",
"Underwater coral reef sanctuary",
"Unemployment Office",
"University Corridor",
"university",
"upstairs",
"Urban farm",
"Urban oasis",
"Urban rooftop farm",
"Used Book Shop",
"Vegan food truck",
"Vegetarian restaurant",
"Veterinary Office",
"village",
"vineyard",
"Vintage arcade",
"Vintage record store",
"Vintage Shop",
"VIP Lounge",
"Virtual reality arcade",
"Virtual Reality",
"Waiting Room",
"Walk-In Closet",
"Warehouse",
"waterbed",
"Waterfall oasis",
"waterfall",
"waterfront",
"waterwheel",
"Wax museum",
"Wealthy Manor",
"web",
"webpage",
"website",
"Wedding Reception",
"Weight Room",
"wet-bar",
"wetland",
"Whale-watching platform",
"wharf",
"Whimsical fairy tale village",
"Whimsical rooftop garden café",
"whirlpool",
"Whiskey bar",
"Wind farm",
"Wine Cellar",
"Winery cellar",
"workplace",
"workshop",
"World of Dreams",
"World's Biggest Shoe",
"world",
"wraparound",
"yacht",
"yard",
"Yarn shop",
"Yoga Class",
"Yoga retreat",
"Zen garden",
"Zen meditation center",
"Zen monastery",
"Zoo"
];

var time = [
"a professional sports game",
"a professional wrestling match",
"a rooftop party",
"a salsa dancing social",
"a silent disco",
"a spoken word poetry event",
"a spoken word poetry workshop",
"a stand-up comedy show",
"a stand-up comedy workshop",
"a street art festival",
"a street food festival",
"a tea tasting ceremony",
"a TED Talk or motivational seminar",
"a TED talk",
"a theater improvisation workshop",
"a vintage car rally",
"a virtual reality experience",
"a whiskey tasting event",
"a wildlife photography workshop",
"a wine and cheese tasting",
"a wine and food pairing event",
"a wine and paint night",
"a wine tasting and vineyard tour",
"a wine tasting class",
"Achieving a personal goal",
"Achieving a personal goal",
"Achieving financial independence",
"Adopting a child",
"Adopting a rescue pet",
"Adventure sports (e.g., skydiving, bungee jumping)",
"Afternoon tea",
"Age of enlightenment",
"Anniversary celebration",
"Art exhibition opening",
"Art exhibition",
"Attending a beer brewing demonstration",
"Attending a beer tasting festival",
"Attending a book signing",
"Attending a car show or exhibition",
"Attending a circus or carnival",
"Attending a cocktail mixing workshop",
"Attending a culinary masterclass with a famous chef",
"Attending a cultural festival",
"Attending a destination wedding",
"Attending a fashion show",
"Attending a film festival",
"Attending a food and wine pairing event",
"Attending a food truck festival",
"Attending a glassblowing demonstration",
"Attending a historical reenactment event",
"Attending a life-changing seminar or workshop",
"Attending a live music jam session",
"Attending a live orchestra performance",
"Attending a live painting performance",
"Attending a live stand-up comedy show",
"Attending a live theater improvisation performance",
"Attending a magic show",
"Attending a major international summit or conference",
"Attending a major music concert",
"Attending a martial arts tournament",
"Attending a masquerade ball",
"Attending a meditation and yoga retreat in Bali",
"Attending a meditation workshop",
"Attending a mindfulness and meditation retreat",
"Attending a mixology class",
"Attending a motivational seminar",
"Attending a murder mystery dinner party",
"Attending a music festival",
"Attending a music production workshop",
"Attending a national sports championship",
"Attending a nature photography workshop",
"Attending a poetry reading or spoken word event",
"Attending a political rally or protest",
"Attending a professional ballet performance",
"Attending a professional boxing match",
"autumn",
"Barbecue party",
"Becoming a caregiver for a loved one",
"Becoming a grandparent",
"Becoming a homeowner",
"Becoming a homeowner",
"Becoming a parent for the first time",
"Becoming a parent",
"Becoming financially independent",
"Being a part of a groundbreaking scientific or technological discovery",
"Being granted citizenship in a new country",
"Being recognized for your work with a prestigious award",
"Birth of a child",
"Birthday celebration",
"Book launch",
"Breaking a personal record",
"Breaking free from a cycle of abuse or toxic environment",
"Breaking free from a toxic relationship",
"Bridal shower",
"Building a strong support network of friends and loved ones",
"Bungee jumping",
"Business anniversary celebration",
"Buying a car",
"Buying a house",
"Celebrating a milestone wedding anniversary",
"Celebrating a personal achievement with loved ones",
"Celebrating a traditional cultural festival",
"Century celebration",
"Charity event",
"Charity fundraiser",
"Chronological exhibition",
"Climbing a famous mountain peak",
"Climbing a mountain or completing a physical challenge",
"Climbing a mountain",
"College reunion",
"college",
"Coming out as LGBTQ+",
"Community service event",
"Completing a challenging academic degree or program",
"Completing a DIY project",
"Completing a home DIY renovation project",
"Completing a home renovation project",
"Completing a self-help personal development course",
"Completing a triathlon",
"Confronting and healing from a childhood trauma",
"Countdown to midnight",
"Creating a work of art that resonates with others",
"curse",
"dawn",
"daylight",
"Destination wedding",
"Discovering a hidden talent or skill",
"Discovering a new passion or interest later in life",
"Discovering and embracing a new cultural identity",
"Discovering one's true identity or sexuality",
"Donating blood or organs",
"dust storm",
"Early morning meditation",
"earthquake",
"Embarking on a solo backpacking adventure",
"Emigrating to a different culture",
"Emigrating to a new country",
"Engagement party",
"Engagement proposal",
"Era of innovation",
"Era-defining moment",
"Escaping a dangerous or abusive relationship",
"Evening gala",
"Experiencing a natural disaster",
"Experiencing a natural disaster",
"Experiencing a significant breakthrough in therapy",
"Experiencing a significant cultural or religious event",
"Experiencing a significant personal or spiritual revelation",
"Experiencing a spiritual awakening",
"Experiencing a total solar eclipse",
"Exploring a bamboo forest",
"Exploring a botanical garden",
"Exploring a cave system",
"Exploring a coral reef through snorkeling",
"Exploring a famous ancient pyramid",
"Exploring a famous ancient ruin",
"Exploring a famous art museum",
"Exploring a famous historical site",
"Exploring a famous national forest",
"Exploring a famous natural wonder",
"Exploring a famous shipwreck",
"Exploring a famous underwater cave",
"Exploring a ghost town",
"Exploring a glacial cave",
"Exploring a haunted house",
"Exploring a hidden beach",
"Exploring a hidden canyon",
"Exploring a hidden cave system",
"Exploring a hidden forest",
"Exploring a hidden gem city",
"Exploring a hidden hot spring",
"Exploring a hidden lake",
"Exploring a hidden mountain peak",
"Exploring a hidden mountain range",
"Exploring a hidden waterfall cave",
"Exploring a hidden waterfall",
"Exploring a historical castle",
"Exploring a historical underground city",
"Exploring a labyrinth",
"Exploring a rainforest",
"Exploring a remote island",
"Exploring a remote waterfall",
"Exploring a sunflower field",
"Exploring an abandoned theme park",
"Exploring an ancient ruin",
"Exploring an ancient temple",
"Exploring an underground cave",
"Exploring an underwater coral reef",
"Facing a life-threatening situation and coming out stronger",
"Family gathering",
"Family holiday traditions",
"Family reunion",
"Family road trip",
"Family vacation",
"Farewell party",
"festival",
"Film premiere",
"Finding a mentor who transforms your life",
"Finding inner peace and contentment",
"Finding one's passion",
"Finding one's passion",
"Finding peace and closure after a period of grief",
"Finding peace and forgiveness in a challenging family situation",
"Finding your purpose or calling in life",
"First concert attended",
"First date",
"First day at a new school",
"First day of college",
"First day of school",
"First day of school",
"First job interview",
"First kiss",
"First paycheck",
"First solo exhibition",
"First time adopting a pet",
"First time attending a live sports event",
"First time bungee jumping",
"First time buying a car",
"First time camping",
"First time cooking a meal",
"First time driving a car",
"First time experiencing snow",
"First time falling in love",
"First time getting a passport",
"First time getting a tattoo",
"First time going on a date",
"First time going on a road trip",
"First time going on a safari",
"First time having sex",
"First time hosting a party",
"First time learning to play a musical instrument",
"First time learning to ride a motorcycle",
"First time learning to swim",
"First time moving out of your parents' house",
"First time public speaking",
"First time riding a bike",
"First time riding a horse",
"First time riding a roller coaster",
"First time scuba diving",
"First time skydiving",
"First time traveling abroad",
"First time traveling solo",
"First time trying a new cuisine",
"First time using public transportation",
"First time visiting a museum",
"First time volunteering",
"First time voting",
"Forgiving someone who deeply hurt you",
"frost",
"Fulfilling a lifelong dream or bucket list item",
"Getting a driver's license",
"Getting a makeover or style transformation",
"Getting a pet",
"Getting a promotion at work",
"Getting a promotion or significant career advancement",
"Getting a tattoo",
"Getting elected for a leadership position",
"Getting married",
"Getting married",
"Going back to school for further education",
"Going on a backcountry skiing expedition",
"Going on a backpacking trip",
"Going on a blind date",
"Going on a camping retreat",
"Going on a camping trip",
"Going on a canyoning expedition",
"Going on a charity bike ride",
"Going on a cross-country cycling adventure",
"Going on a cross-country road trip",
"Going on a cruise",
"Going on a culinary tour of a foreign country",
"Going on a cycling tour",
"Going on a desert safari",
"Going on a fishing trip",
"Going on a foodie tour",
"Going on a ghost tour or paranormal investigation",
"Going on a glamping trip",
"Going on a heritage tour to trace ancestral roots",
"Going on a hiking expedition",
"Going on a hiking trip",
"Going on a historical tour or guided walk",
"Going on a historical tour",
"Going on a horseback riding adventure in the desert",
"Going on a horseback riding adventure in the mountains",
"Going on a horseback riding adventure in the wilderness",
"Going on a horseback riding adventure on the beach",
"Going on a horseback riding adventure",
"Going on a horseback riding vacation in a tropical destination",
"Going on a horseback riding vacation in a vineyard",
"Going on a horseback riding vacation in the countryside",
"Going on a horseback riding vacation in the forest",
"Going on a horseback riding vacation in the mountains",
"Going on a horseback riding vacation on a ranch",
"Going on a hot air balloon festival at night",
"Going on a hot air balloon festival",
"Going on a hot air balloon ride during a sunset",
"Going on a hot air balloon ride over a mountain range",
"Going on a hot air balloon ride over a national park",
"Going on a hot air balloon ride over a scenic landscape",
"Going on a hot air balloon ride over a vineyard",
"Going on a hot air balloon safari at sunrise",
"Going on a hot air balloon safari",
"Going on a kayaking expedition",
"Going on a meditation retreat",
"Going on a motorcycle racing track day",
"Going on a motorcycle road trip",
"Going on a motorhome road trip across a country",
"Going on a mountain biking excursion",
"Going on a multi-day canyoneering expedition",
"Going on a multi-day cross-country running trip",
"Going on a multi-day cross-country skiing trip",
"Going on a multi-day cycling trip",
"Going on a multi-day hiking and camping trip",
"Going on a multi-day horse trek",
"Going on a multi-day kayaking and camping trip",
"Going on a multi-day kayaking expedition",
"Going on a multi-day mountain biking trip",
"Going on a multi-day paragliding trip",
"Going on a multi-day river rafting trip",
"Going on a multi-day rock climbing trip",
"Going on a multi-day sailing trip",
"Going on a multi-day scuba diving trip",
"Going on a multi-day skiing trip",
"Going on a multi-day snowboarding trip",
"Going on a multi-day stand-up paddleboarding trip",
"Going on a multi-day wildlife photography expedition",
"Going on a photo safari in the wild",
"Going on a photography expedition to a remote location",
"Going on a photography expedition to capture wildlife",
"Going on a photography safari",
"Going on a river rafting adventure",
"Going on a road trip with friends",
"Going on a rock climbing expedition",
"Going on a safari",
"Going on a ski trip",
"Going on a snorkeling expedition",
"Going on a solo backpacking adventure",
"Going on a solo retreat or sabbatical",
"Going on a spiritual pilgrimage",
"Going on a spontaneous adventure",
"Going on a sunrise hike",
"Going on a surfing trip",
"Going on a volunteer trip abroad",
"Going on a weekend camping trip with friends",
"Going on a weekend getaway",
"Going on a whale watching excursion",
"Going on a wildlife conservation trip",
"Going on a wildlife safari",
"Going on a wine and cheese tasting cruise",
"Going on a wine tasting tour in Napa Valley",
"Going on a wine tasting tour",
"Going on a zip-lining adventure",
"Going on an archaeological dig",
"Going through a divorce",
"Going through a significant career change",
"Golden hour",
"Gradually repairing a broken relationship",
"Graduating from a specialized training program",
"Graduating from a specialized training program",
"Graduating from college",
"Graduating from university",
"Graduation ceremony",
"Graduation commencement speech",
"Graduation party",
"Having a child",
"Helping someone else achieve their dreams",
"High school reunion",
"Historical reenactment",
"Honeymoon",
"Hosting a charity fundraising event",
"Hosting a game night with friends",
"Hosting a themed costume party",
"Hosting a themed party",
"Hourglass meditation",
"House renovation or remodeling",
"Housewarming gathering",
"Housewarming party",
"hurricane",
"Instant gratification",
"Job anniversary celebration",
"Job interview",
"Job promotion",
"Joining a club or organization",
"Joining a community choir",
"Joining a local sports league",
"kiss",
"knock",
"Late-night rendezvous",
"Launching a successful startup or business venture",
"Leap year celebration",
"Learning a new language fluently",
"Learning a new language",
"Learning to create 3D animations",
"Learning to do a aerial yoga",
"Learning to do a backflip",
"Learning to do acrobatics",
"Learning to do Brazilian jiu-jitsu",
"Learning to do breakdancing",
"Learning to do Capoeira",
"Learning to do fire dancing",
"Learning to do flamenco dancing",
"Learning to do kickboxing",
"Learning to do krumping",
"Learning to do Kung Fu",
"Learning to do Muay Thai boxing",
"Learning to do Muay Thai kickboxing",
"Learning to do parkour",
"Learning to do pole dancing",
"Learning to do salsa dancing",
"Learning to do Taekwondo",
"Learning to do tai chi",
"Learning to do woodworking",
"Learning to fly a small aircraft",
"Learning to juggle",
"Learning to knit or crochet",
"Learning to love and accept yourself unconditionally",
"Learning to make homemade pasta",
"Learning to make pottery",
"Learning to make stained glass",
"Learning to make sushi",
"Learning to manage and overcome chronic illness or disability",
"Learning to perform magic tricks",
"Learning to play a musical instrument",
"Learning to play a new musical instrument",
"Learning to play chess",
"Learning to play poker",
"Learning to play the guitar",
"Learning to ride a horse",
"Learning to ride a motorcycle",
"Learning to scuba dive",
"Learning to surf",
"Learning to write calligraphy",
"Leaving a toxic work environment and finding fulfillment elsewhere",
"lecture",
"Lifetime achievement award",
"Losing a loved one",
"Losing a loved one",
"Making a lifelong commitment to personal growth and self-improvement",
"Making a significant financial investment",
"Marathon race",
"Marathon running",
"Meeting a lifelong role model",
"Meeting someone who becomes your lifelong best friend",
"Mentoring someone and seeing them succeed",
"Midday siesta",
"Midnight marathon",
"Moment of clarity",
"Moment of truth",
"monsoon",
"Morning rush hour",
"Mountain climbing or hiking expedition",
"Moving abroad",
"Moving to a different country",
"Moving to a new country",
"Moving to a new country",
"Moving to a new home",
"Music concert",
"Navigating a major career setback",
"Navigating a successful career transition",
"New business opening",
"New job orientation",
"New pet adoption",
"New Year's Eve celebration",
"Opening a business",
"Organizing a surprise birthday party",
"Overcoming a deep-rooted insecurity or self-doubt",
"Overcoming a deep-seated fear or phobia",
"Overcoming a fear or phobia",
"Overcoming a lifelong habit or addiction",
"Overcoming a major personal setback or failure",
"Overcoming addiction",
"Participating in a charity run or walk",
"Participating in a coastal cleanup initiative",
"Participating in a community theater production",
"Participating in a competitive cooking show",
"Participating in a drum circle",
"Participating in a flash mob",
"Participating in a fundraising event",
"Participating in a hackathon or tech event",
"Participating in a hackathon",
"Participating in a humanitarian mission or volunteer abroad",
"Participating in a poker tournament",
"Participating in a professional dance competition",
"Participating in a reality TV show competition",
"Participating in a scientific research study",
"Participating in a street art installation project",
"Participating in a yoga or meditation retreat",
"Pendulum swing",
"picnic",
"Planting a garden",
"Planting a tree and watching it grow",
"Prom night",
"Publishing a book or article",
"Publishing a book",
"Puppy/kitten adoption",
"Quinceañera",
"Reaching a fitness goal",
"Reaching a personal goal",
"Reaching a personal milestone",
"Reaching a savings or financial goal",
"Receiving a scholarship",
"Receiving an award",
"Reconnecting with a long-lost friend or family member",
"Reconnecting with an old friend",
"Recovering from a mental health crisis",
"Recovering from a serious illness",
"Recovering from a serious injury",
"Recovering from a severe mental or physical trauma",
"Recovering from addiction",
"Rehearsal dinner",
"Religious ceremony",
"Retirement ceremony",
"Retirement party",
"Retirement trip",
"Retiring from a long-term career",
"Retiring from work",
"Reunion with a long-lost friend",
"Reuniting with a long-lost relative",
"Road cycling or biking race",
"Road trip",
"Running a charity marathon",
"Running a marathon or completing a physical feat",
"Running a marathon",
"Scientific discovery",
"Scoring a winning goal",
"Scuba diving in a coral reef",
"Scuba diving or snorkeling experience",
"Seasonal transition",
"Second chance opportunity",
"Serving in the military or completing military service",
"Skydiving from a plane",
"Solo travel adventure",
"Sporting event victory",
"Starting a blog or personal website",
"Starting a book club",
"Starting a business",
"Starting a charity fundraiser",
"Starting a collection (e.g., stamps, coins, vinyl records)",
"Starting a community composting initiative",
"Starting a community service project",
"Starting a cooking blog",
"Starting a dance fitness class",
"Starting a digital nomad lifestyle",
"Starting a DIY craft business",
"Starting a family through adoption or surrogacy",
"Starting a family",
"Starting a fashion blog",
"Starting a fitness challenge",
"Starting a fitness journey",
"Starting a garden or growing your own food",
"Starting a garden",
"Starting a homebrewing project",
"Starting a journal or diary",
"Starting a meditation practice",
"Starting a mentorship program",
"Starting a mindfulness practice",
"Starting a monthly game night with friends",
"Starting a movement or creating positive change",
"Starting a new career",
"Starting a new hobby or passion project",
"Starting a new job",
"Starting a new relationship after a long period of being single",
"Starting a nonprofit organization",
"Starting a club",
"Starting a permaculture garden",
"Starting a podcast",
"Starting a side hustle",
"Starting a small business",
"Starting a social movement that inspires change",
"Starting a successful business",
"Starting a travel blog",
"Starting a vintage clothing collection",
"Starting a wine tasting club",
"Starting a YouTube channel",
"Starting a zero-waste lifestyle",
"Sundial ceremony",
"Sundown ritual",
"sunrise",
"sunset",
"Supporting a loved one through a life-threatening illness",
"Surprise marriage proposal",
"Surprise party",
"Surviving a car accident",
"Surviving a life-threatening illness",
"Surviving a natural disaster or life-threatening event",
"Surviving a near-death experience",
"Sweet sixteen party",
"Taking a calligraphy writing class",
"Taking a candle making class",
"Taking a ceramics painting class",
"Taking a cooking or baking class",
"Taking a creative writing workshop",
"Taking a cross-country train journey",
"Taking a dance class (e.g., salsa, hip-hop)",
"Taking a filmmaking course",
"Taking a flower arranging workshop",
"Taking a gap year to travel and explore the world",
"Taking a gardening class",
"Taking a glassblowing class",
"Taking a helicopter skiing trip",
"Taking a helicopter tour",
"Taking a hot air balloon ride",
"Taking a hot springs bath",
"Taking a jewelry making class",
"Taking a knitting or crochet workshop",
"Taking a leap of faith and making a major life change",
"Taking a leatherworking class",
"Taking a martial arts class",
"Taking a metalworking class",
"Taking a painting class",
"Taking a photography workshop",
"Taking a pottery-making class",
"Taking a sabbatical or gap year",
"Taking a sailing lesson",
"Taking a sailing trip around a tropical island",
"Taking a scenic hot air balloon ride",
"Taking a screen acting class",
"Taking a screenwriting course",
"Taking a sculpting class",
"Taking a self-defense class",
"Taking a self-defense or martial arts class",
"Taking a stained glass workshop",
"Taking a stand-up paddleboarding lesson",
"Taking a swing dance class",
"Taking a theater acting workshop",
"Taking a trapeze class",
"Taking a voice acting class",
"Taking a watercolor painting class",
"Taking a web design course",
"Taking a wilderness backpacking trip",
"Taking a wilderness survival course",
"Taking a wine appreciation course",
"Taking a woodworking class",
"Taking a yoga retreat",
"Taking an acting for film course",
"Taking an acting improvisation class",
"Taking part in a beach clean-up",
"Taking part in a charity run or walk",
"Taking part in a community gardening project",
"Taking part in a traditional cultural dance performance",
"Teaching others and making a positive impact in their lives",
"Temporal distortion",
"Theater performance",
"thunderstorm",
"Time capsule opening",
"Time management workshop",
"Time travel experiment",
"Time zone adjustment",
"Time-lapse photography",
"Time-sensitive deadline",
"Time-sensitive decision",
"Time-traveling adventure",
"Timelapse of nature",
"Timeless love story",
"Timeline of achievements",
"tornado",
"Traveling solo for an extended period",
"Traveling to a place that profoundly changes your perspective",
"Traveling to a tropical paradise",
"trek",
"Trying out archery",
"Trying out stand-up paddleboarding",
"tsunami",
"Volunteer work",
"Volunteering abroad",
"Volunteering at a homeless shelter",
"Volunteering at an orphanage abroad",
"Volunteering for a meaningful cause",
"webinar",
"Wedding ceremony",
"Wine tasting in a vineyard",
"Winning a competition or contest",
"Winning a lottery or sweepstakes",
"Winning a major award or competition",
"Winning a major award",
"Winning a scholarship",
"Winter solstice",
"Witnessing a historic event",
"Witnessing a meteor shower",
"Witnessing a meteorological phenomenon (e.g., double rainbow, lightning storm)",
"Witnessing a meteorological phenomenon",
"Witnessing a natural phenomenon (e.g., meteor shower, solar eclipse)",
"Witnessing a rare celestial event",
"Witnessing a total solar eclipse",
"Witnessing the birth of a baby animal",
"Witnessing the birth of your child",
];

var person = [
"1st Mate",
"1st Violin",
"A Regular",
"accountant",
"achiever",
"activist",
"actor",
"actress",
"admin",
"administrator",
"adult",
"adviser",
"advocate",
"agent",
"aide",
"airman",
"Airplane Passengers",
"alien",
"allergist",
"ambassador",
"analyst",
"anarchist",
"ancestor",
"android",
"anesthesiologist",
"angel",
"anybody",
"anyone",
"Apprentice",
"archaeologist",
"archer",
"architect",
"Archivist",
"Arms Dealer",
"arthur",
"artist",
"Artistic Director",
"Assassin",
"assistant",
"associate",
"astrologer",
"Astronaut",
"Astronomer",
"atheist",
"athlete",
"attacker",
"attendant",
"attorney",
"audience",
"aunt",
"author",
"authority",
"automaton",
"baby",
"Babysitter",
"bachelor",
"baker",
"balloonist",
"band",
"bandolier",
"Bank Officer",
"banker",
"barber",
"baritone",
"bartender",
"batter",
"beggar",
"believer",
"Bellhop",
"beneficiary",
"bidder",
"Biologist",
"bird-watcher",
"Bitcoin Expert",
"Blacksmith",
"blogger",
"bomber",
"bondsman",
"boogeyman",
"borrower",
"bowler",
"boxer",
"boy",
"boyfriend",
"brewer",
"bride",
"broker",
"brother-in-law",
"brother",
"Buggy Driver",
"builder",
"bullfighter",
"burglar",
"Bus Driver",
"businessman",
"butcher",
"butler",
"buyer",
"caddy",
"cadet",
"Caller",
"Camera Seller",
"camper",
"candidate",
"cannibal",
"captain",
"captor",
"Car Mechanic",
"Car Owner",
"carol",
"carpenter",
"cashier",
"Castaway",
"Cat Food Chef",
"catcher",
"celebrity",
"centurion",
"CEO",
"chairman",
"chairperson",
"champion",
"chap",
"chaplain",
"character",
"charlatan",
"chauffeur",
"chauvinist",
"chef",
"chief",
"child",
"children",
"choir",
"chorus",
"citizen",
"City Person",
"civilian",
"classmate",
"cleaner",
"clergyman",
"cleric",
"clerk",
"client",
"clone",
"co-producer",
"coach",
"colleague",
"collector",
"columnist",
"comic",
"commander",
"committee",
"community",
"commuter",
"competitor",
"composer",
"comptroller",
"con",
"Concept Artist",
"conductor",
"congregation",
"congress",
"congressman",
"congressperson",
"congresswoman",
"conservative",
"contractor",
"cook",
"cop",
"copyright",
"copywriter",
"correspondent",
"council",
"councilor",
"counselor",
"counterpart",
"couple",
"cousin",
"cowboy",
"craftsman",
"creator",
"creature",
"creditor",
"crew member",
"crew",
"crewman",
"crewmate",
"crewmen",
"cricketer",
"Crime Boss",
"criminal",
"critic",
"crook",
"crowd",
"crush",
"cultivator",
"customer",
"Cyclist",
"dad",
"daddy",
"dame",
"dancer",
"daughter",
"dealer",
"debtor",
"defendant",
"defender",
"democrat",
"dentist",
"deputy",
"descendant",
"designer",
"destroyer",
"detainee",
"detective",
"developer",
"devil",
"dick",
"dictator",
"dipstick",
"director",
"distributor",
"diver",
"doc",
"doctor",
"Dog Food Chef",
"donor",
"doubter",
"dramaturge",
"dreamer",
"driver",
"drummer",
"drunk",
"dude",
"eavesdropper",
"editor",
"elf",
"employee",
"employer",
"EMT",
"enemy",
"engineer",
"entrepreneur",
"evaluator",
"ex-husband",
"ex-wife",
"examiner",
"executive",
"executor",
"Expecting Mother",
"Experiment Physicist",
"expert",
"explorer",
"faculty",
"fairies",
"fairy",
"family",
"farmer",
"father-in-law",
"father",
"fellow",
"female",
"fighter",
"fireman",
"fisherman",
"Fishing Boat Captain",
"fishmonger",
"Flight Tower",
"folk",
"follower",
"fool",
"forager",
"foreigner",
"Foreman",
"Forest Guide",
"Forest Ranger",
"Forger",
"Foster Parent",
"fraudster",
"freak",
"friend",
"friends",
"Future Self",
"Gambler",
"Gardener",
"geek",
"general",
"genie",
"gentleman",
"ghost",
"giant",
"girl",
"girlfriend",
"girls",
"god",
"goddess",
"godfather",
"godmother",
"godparent",
"Golden Goose",
"governor",
"grandchild",
"granddaughter",
"grandfather",
"grandmom",
"grandmother",
"grandpa",
"grandparent",
"grandson",
"granny",
"grasshopper",
"great-grandfather",
"great-grandmother",
"guard",
"guerrilla",
"guest",
"guide",
"guitarist",
"guy",
"gymnast",
"Hairdresser",
"half-brother",
"half-sister",
"Handler",
"handmaiden",
"harpooner",
"harvester",
"heart-throb",
"heir",
"hermit",
"historian",
"Hobo",
"Homeowner",
"Homewrecker",
"honoree",
"host",
"Hostage",
"hostess",
"Hotel Visitor",
"housewife",
"hugger",
"human",
"hunchback",
"hunter",
"husband",
"icon",
"idiot",
"immigrant",
"impostor",
"in-laws",
"individual",
"Informant",
"inhabitant",
"inspector",
"instructor",
"instrumentalist",
"interloper",
"interpreter",
"intervenor",
"interviewer",
"invader",
"investigator",
"investor",
"Janitor",
"Jester",
"jeweller",
"jockey",
"journalist",
"judge",
"juggernaut",
"julienne",
"jury",
"keeper",
"kid",
"killer",
"king",
"knight",
"laborer",
"lad",
"lady",
"lamb",
"lambkin",
"Landscaper",
"lawmaker",
"lawyer",
"leader",
"legend",
"legislator",
"legislature",
"lender",
"leveret",
"liar",
"lieutenant",
"Lighthouse Keeper",
"Limo Driver",
"linguist",
"loafer",
"Lobbyist",
"Local Artist",
"local",
"Logger",
"lord",
"louse",
"lout",
"lover",
"lumberman",
"madam",
"maestro",
"maggot",
"Magician",
"maid",
"maiden",
"mailer",
"mailman",
"maintainer",
"Maitre D",
"maker",
"male",
"mama",
"man",
"manager",
"maniac",
"manservant",
"manufacturer",
"marines",
"mark",
"marketer",
"marksman",
"master",
"matchmaker",
"mate",
"mayor",
"mechanic",
"men",
"mentor",
"merchant",
"messenger",
"metallurgist",
"midwife",
"migrant",
"Millionaire",
"mime",
"minion",
"minister",
"minor",
"miss",
"Mission Chief",
"missionary",
"mixer",
"mobster",
"model",
"mom",
"monger",
"monitor",
"monk",
"moron",
"mother-in-law",
"mother",
"mover",
"Museum Curator",
"musician",
"neighbor",
"nephew",
"nestling",
"nestmate",
"neurobiologist",
"New CEO",
"New Hunter",
"New Parent",
"Newlywed",
"niece",
"ninja",
"nobody",
"nonbeliever",
"nonconformist",
"numismatist",
"nun",
"nurse",
"nymph",
"ocelot",
"octopus",
"Off-Duty Cop",
"officer",
"official",
"Old Hunter",
"operator",
"ophthalmologist",
"opossum",
"opportunist",
"optimist",
"Optometrist",
"orangutan",
"orator",
"outlaw",
"outrigger",
"owner",
"pagan",
"painter",
"pansy",
"pantologist",
"papa",
"paramedic",
"Parent-In-Law",
"parent",
"partner",
"Party Animal",
"passenger",
"pastor",
"pastoralist",
"patentee",
"patriarch",
"patriot",
"patroller",
"patron",
"payee",
"peasant",
"peer",
"people",
"perp",
"person",
"personnel",
"Pet Groomer",
"Pet Owner",
"Pet Toad",
"pharmacist",
"pheasant",
"philosopher",
"photographer",
"Physical Trainer",
"pianist",
"Piano Tuner",
"Piercer",
"pilgrim",
"pilot",
"pimp",
"pioneer",
"pirate",
"pitcher",
"plaintiff",
"player",
"playwright",
"plowman",
"plumber",
"poet",
"police",
"policeman",
"politician",
"pollutant",
"Pool Boy",
"Postal Worker",
"Potential Investor",
"practitioner",
"president",
"primate",
"prince",
"princess",
"principal",
"printer",
"Prison Guard",
"prisoner",
"processor",
"proctor",
"producer",
"professor",
"progenitor",
"Programmer",
"prophet",
"proponent",
"proprietor",
"prosecutor",
"provider",
"pruner",
"psychiatrist",
"psychoanalyst",
"psychologist",
"publisher",
"pupil",
"puritan",
"quartet",
"queen",
"questioner",
"rabbi",
"racer",
"rainmaker",
"rambler",
"rancher",
"ranger",
"Rare Book Collectors",
"reader",
"rebel",
"rebellion",
"receiver",
"reception",
"receptor",
"recipient",
"recorder",
"Recovering Patient",
"recruit",
"redhead",
"Referee",
"Regular Client",
"Regular",
"regulator",
"reject",
"relation",
"relative",
"reporter",
"representative",
"republican",
"researcher",
"resident",
"revenant",
"Rich Relative",
"rider",
"Rival Explorers",
"Robber",
"robot",
"rocker",
"Room Service",
"roommate",
"rosemary",
"ruler",
"runaway",
"sage",
"sailor",
"saint",
"salesman",
"samurai",
"savior",
"scarecrow",
"schizophrenic",
"scholar",
"Schoolbus Driver",
"scientist",
"scout",
"screamer",
"Scriptwriter",
"Sculptor",
"secretariat",
"secretary",
"Security Guard",
"seeder",
"seeker",
"seller",
"senator",
"sender",
"senior",
"servant",
"server",
"settler",
"shaker",
"shareholder",
"shark",
"shipper",
"shoemaker",
"shopper",
"sibling",
"singer",
"sir",
"sister-in-law",
"sister",
"sisters",
"Skateboard Seller",
"slave",
"slider",
"smith",
"sneaker",
"snob",
"snorer",
"snowflake",
"snowman",
"socialist",
"Socialite",
"soldier",
"solicitor",
"somebody",
"someone",
"son",
"soprano",
"Sous-Chef",
"speaker",
"specialist",
"spokesman",
"spokeswoman",
"sport",
"Sports Coach",
"sportsman",
"spouse",
"sprinter",
"spy",
"squatter",
"Stablehand",
"staff",
"Star Pupil",
"step-aunt",
"step-brother",
"step-daughter",
"step-father",
"step-grandfather",
"step-grandmother",
"step-mother",
"step-sister",
"step-son",
"stitcher",
"stranger",
"strawman",
"Street Hustler",
"Street Racer",
"Street Vendor",
"student",
"Stunt Driver",
"subcontractor",
"Submarine Pilot",
"submitter",
"sucker",
"summer",
"Superstar",
"Supervillian",
"supplier",
"supporter",
"surgeon",
"survivor",
"suspect",
"tailor",
"Tatoo Artist",
"tattler",
"Taxi Driver",
"taxpayer",
"teacher",
"Team Owner",
"team",
"teammate",
"technician",
"technologist",
"teen",
"teenager",
"Telephone Operator",
"teller",
"temp",
"temptress",
"tenant",
"terrorist",
"The Last Kid",
"therapist",
"thief",
"thug",
"Ticket Agent",
"Torturer",
"tosser",
"tough-guy",
"tourist",
"trader",
"trafficker",
"trail patrol",
"trainer",
"tramp",
"Translator",
"traveler",
"tribe",
"Trophy Spouse",
"trustee",
"tuber",
"twins",
"Two Judges",
"Two Shoe Designers",
"UN Ambassador",
"uncle",
"Understudy",
"undertaker",
"Union Leader",
"UPS Deliverer",
"user",
"usher",
"vagrant",
"valentine",
"vampire",
"vegetarian",
"vet",
"veteran",
"veterinarian",
"victim",
"viewer",
"vintner",
"visitor",
"volunteer",
"voter",
"wad",
"waiter",
"waitress",
"walker",
"wannabe",
"warden",
"warlock",
"warlord",
"warren",
"warrior",
"washer",
"watcher",
"Watchermaker",
"watchmaker",
"Wedding Planner",
"weeder",
"weekender",
"Werewolf",
"wholesaler",
"wife",
"wingman",
"wiseguy",
"witch",
"witness",
"Wizard",
"woman",
"women",
"Woodsman",
"worker",
"workforce",
"worshiper",
"wrestler",
"writer",
"X-Ray Tech",
"Yacht Salesman",
"youngster",
"zoologist"
];

//Function to create OBJECTS in Column A
function newObj(){
  var divs = document.getElementsByClassName("sp_word objDisp");

  for(let i=0; i < divs.length; i++){
    var randomObj = Math.floor(Math.random() * (obj.length));
    divs[i].innerHTML = obj[randomObj];
  }
}

//Function to create Places
function newPlace(){
  var divs = document.getElementsByClassName("sp_word placeDisp");

  for(let i=0; i < divs.length; i++){
    var randomPlace = Math.floor(Math.random() * (place.length));
    divs[i].innerHTML = place[randomPlace];
  }
}

//Function to create Time/events
function newTime(){
  var divs = document.getElementsByClassName("sp_word timeDisp");

  for(let i=0; i < divs.length; i++){
    var randomTime = Math.floor(Math.random() * (time.length));
    divs[i].innerHTML = time[randomTime];
  }
}

//Function to create Person/Personas
function newPerson(){
  var divs = document.getElementsByClassName("sp_word personDisp");

  for(let i=0; i < divs.length; i++){
    var randomPerson = Math.floor(Math.random() * (person.length));
    divs[i].innerHTML = person[randomPerson];
  }
}

//Function to clear all text
function clearTextSp(){
  var divs = document.getElementsByClassName("sp_word");

  for(let i=0; i < divs.length; i++){
    divs[i].innerHTML = "";
  }
}

//Function to create All new words
function allNewSp(){
	document.getElementsByClassName("sp_word").innerHTML = newObj(),newPlace(),newTime(),newPerson();
}